import { ClassToggleService, HeaderComponent } from '@coreui/angular';
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { PetService } from 'src/app/services/pet.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
})
export class DefaultHeaderComponent extends HeaderComponent {

  @Input() sidebarId: string = "sidebar";

  public newMessages = new Array(4)
  public newTasks = new Array(5)
  public newNotifications = new Array(5)

  constructor(
    private classToggler: ClassToggleService,
    private router: Router,
    private petService: PetService,) {
    super();
  }

  logoutAccount() {
    this.petService.logout(localStorage.getItem('access_token') || '').subscribe();
    localStorage.removeItem('access_token');
    this.router.navigate(['login']);
  }
}
